import React, { useEffect, useRef, useState, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { fetchProduit } from "../../Redux/produitReduce";
import { commandeAdded, verifCmd, getNumCommandGros } from "../../Redux/commandeReduce";
import { verification } from "../../Redux/usersReduce";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { fetchGrossisteSite } from "../../Redux/grossisteReduce";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import SweetAlert from "react-bootstrap-sweetalert";
import Swal from 'sweetalert2';

function AddCommandeParProduit({ obj, client }) {
  const navigate = useHistory();
  const dispatch = useDispatch();
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const idUser = obj.user.id_role == 6 ? obj.user.id_grossiste : null;
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const saveTableCalled = useRef(false);
  const [entities, setEntities] = useState([]);
  const [numCmd, setNumCmd] = useState(null);
  const [alert, setAlert] = useState(null);
  const [save, setSave] = useState(false);
  const [total, setTotal] = useState(0);

  //Produit en vrac
  const [resteZero, setResteZero] = useState(0);
  const [entitiesReste, setEntitiesReste] = useState([]);

  const [remise_industrie3, setRemise_industrie3] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie3 : 0);
  const [remise_industrie2, setRemise_industrie2] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie2 : 0);
  const [fourSelected, setFourSelected] = React.useState(null);
  const [optionFour, setOptionFour] = React.useState([
    {
      value: "",
      label: t("Wholesaler"),
      isDisabled: true,
    },
  ]);
  //date Auj
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  var day = currentDate.getDate().toString().padStart(2, '0');
  var formattedDate = year + '-' + month + '-' + day;
  const [entitiesEntete, setEntitiesEntete] = useState([{ Date: formattedDate, id_grossiste: idUser, Grossiste: null, Numero: null }]);

  //Produit
  const [produitSelect, setProduitSelect] = React.useState([]);
  const [optionProduit, setOptionProduit] = React.useState([
    {
      value: "",
      label: "Produit",
      isDisabled: true,
    },
  ]);

  const getNumCmd = useCallback(async (idUser) => {
    // Get the last command number for this user
    const num = await dispatch(getNumCommandGros({ id_grossiste: idUser }));

    const now = new Date();
    const currentYear = now.getFullYear().toString().slice(-2); // e.g., "25"
    const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0"); // e.g., "09"

    let formattedNum = '';

    if (!num.payload.num) {
      // No existing number → start at 001
      formattedNum = `CD-${currentYear}-${currentMonth}-001`;
    } else {
      // Split last number: "CD-25-09-007"
      const parts = num.payload.num.split("-");
      const existingYear = parts[1];
      const existingMonth = parts[2];
      const lastIncrement = parseInt(parts[3]);

      // Increment if same month & year, else reset
      const newIncrement =
        existingYear === currentYear && existingMonth === currentMonth
          ? lastIncrement + 1
          : 1;

      formattedNum = `CD-${currentYear}-${currentMonth}-${newIncrement
        .toString()
        .padStart(3, "0")}`;
    }

    // Update state
    setNumCmd(formattedNum);

    setEntitiesEntete(prev => {
      if (!prev || prev.length === 0) return [{ Numero: formattedNum }]; // create first row if empty
      const updated = [...prev];
      updated[0] = { ...updated[0], Numero: formattedNum }; // update existing first row
      return updated;
    });


  }, [dispatch, entitiesEntete]);

  //get Produit
  const getproduit = useCallback(async (client) => {
    var type = await dispatch(fetchProduit({ client }));
    var entities = type.payload;
    var arrayOption = [];

    entities.forEach((e) => {

      arrayOption.push({
        value: e.id,
        label: e.Designation_1,
        label: e.Designation_1,
        code: e.Code_PCT,
        code_article: e.Code_article,
        prix: parseFloat(e.Prix).toFixed(3),
        id_site: e.id_site,
        tag: e.tag,
        Remise: e.Remise,
        type: e.type,
        cartonnage: e.Coefficient_UC,
        reste: null
      });
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);



  function AjoutLigne(event) {
    var list = [];
    if (entities.length > 0) list = [...entities];
    list[list.length] = {
      index: entities.length,
      designation: null,
      Quantite: 0,
      idProduit: null,
      code: '',
      prix: 0,
      tag: 0,
      code_article: '',
      reste: null,
      cartonnage: null,
      Remise: null,
      id_site: null,
      total: 0,
      type: null,
      nb: 0,
    };
    setEntities(list);
  }

  const removeProduit = useCallback(
    async (list2, select, id) => {
      var list = [...list2]
      list[id].idProduit = null;
      list[id].code = null;
      list[id].designation = null;
      list[id].prix = 0;
      list[id].total = 0;
      list[id].nb = 0;
      list[id].reste = 0;
      list[id].tag = 0;
      list[id].Remise = 0;
      list[id].code_article = null;
      list[id].type = null;
      select[id] = null;
      setProduitSelect(select);
      setEntities(list);
      calculateTotalSum(list)
    },
    []
  );

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessageProduit = (entities, produitSelect, rowIndex, v, obj, remise_industrie2, remise_industrie3) => {
    var e = [...entities];
    console.log(obj)
    const index = e.findIndex(item => item.idProduit === v.value);
    var select = [...produitSelect];
    select[rowIndex] = null
    setProduitSelect(select);
    if (index !== -1) {

      setAlert(
        <SweetAlert
          title=""
          style={{ display: "block", marginTop: "-100px" }}
          success
          onConfirm={() => confirmProduit(entities, produitSelect, rowIndex, v, obj, remise_industrie2, remise_industrie3)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("yes")}
          cancelBtnText={t("no")}
          showCancel
        >
          <h3 className="alert-title">{t("valider_produit")}</h3>
          {t("valider_produit_msg")}?
        </SweetAlert>
      );
    } else {
      confirmProduit(entities, produitSelect, rowIndex, v, obj, remise_industrie2, remise_industrie3)
    }
  };



  const confirmProduit = useCallback(
    async (entities, produitSelect, rowIndex, v, obj, remise_industrie2, remise_industrie3) => {
      var e = [...entities];
      var select = [...produitSelect];
      hideAlert();

      e[rowIndex].index = rowIndex;
      e[rowIndex].idProduit = v.value;
      e[rowIndex].designation = v.label;
      e[rowIndex].code = v.code;
      e[rowIndex].code_article = v.code_article;
      e[rowIndex].prix = v.prix;
      e[rowIndex].type = v.type;
      e[rowIndex].cartonnage = v.cartonnage;
      e[rowIndex].id_site = v.id_site;

      console.log(obj)
      // Determine remise: if v.Remise === 1, use industrie remise else 1 (no discount)
      e[rowIndex].Remise =
        v.Remise === 1
          ? client === "/medis"
            ? remise_industrie2
            : remise_industrie3
          : 0;
      e[rowIndex].reste = v.reste;
      e[rowIndex].tag = v.tag;

      let quantite = parseInt(e[rowIndex].Quantite) || 0;

      // Adjust quantity if cartonnage > 0 and some conditions met
      if (v.cartonnage > 0 && quantite / v.cartonnage >= 0.6 && v.tag == 2) {
        quantite = Math.ceil(quantite / v.cartonnage) * v.cartonnage;

        const seuil = v.cartonnage * 0.6;
        e[rowIndex].syle = "red"
        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
      }

      e[rowIndex].Quantite = quantite;

      e[rowIndex].nb =
        v.cartonnage > 0 && quantite ? parseInt(quantite / v.cartonnage) : 0;

      if (quantite && quantite < v.cartonnage) {
        e[rowIndex].reste = v.cartonnage - quantite;
      } else if (quantite % v.cartonnage > 0) {
        e[rowIndex].reste = v.cartonnage - (quantite % v.cartonnage);
      } else {
        e[rowIndex].reste = 0;
      }
      if ((e[rowIndex].tag == 1) && e[rowIndex].reste > 0) {
        e[rowIndex].Quantite += e[rowIndex].reste
        e[rowIndex].reste = 0
        e[rowIndex].nb += 1
        e[rowIndex].syle = "red"
        notify(2, "Le produit n’est recommandable que par multiple de carton");
      }

      // Calculate remise as decimal (if remise > 1, assume percentage and convert)
      let remiseDecimal = 0;
      if (e[rowIndex].Remise && e[rowIndex].Remise !== 0) {
        remiseDecimal =
          typeof e[rowIndex].Remise === "number"
            ? e[rowIndex].Remise
            : parseFloat(e[rowIndex].Remise);
        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
      }

      // Calculate total with remise discount applied
      e[rowIndex].total = quantite
        ? (v.prix * quantite * (1 - remiseDecimal)).toFixed(3)
        : 0;

      // Update the select array for controlled select input
      select[rowIndex] = v;
      setProduitSelect(select);

      // Recalculate overall totals or sums if needed
      calculateTotalSum(e);

      // Update entities state
      setEntities(e);
    },
    []
  );

  function getProduitReste(list, resteZero) {
    const filteredList = list.filter(item => {
      if (resteZero === 1) {
        if (item.idProduit != null) return item.reste != 0 && item.reste != null;
      } else {
        return true;
      }
    });
    setEntitiesReste(filteredList)
  }


  function deleteLigne(nb) {
    if (entities.length > 1) {
      var filtered = produitSelect.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      setProduitSelect(filtered);
      var filtered = entities.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });

      calculateTotalSum(filtered)
      setEntities(filtered);
      notify(1, t("supprimer_succes"));
    } else {
      notify(2, t("contient_ligne"));
    }
  }

  const saveTable = useCallback(
    async (entities, entitiesEntete, total) => {

      var verif = true;
      var ligneMsg = []

      if (entities.length > 0) {

        var verifReste = true;
        entities.forEach((data) => {
          if ((data.tag == 1) && data.reste > 0) verifReste = false;
        });

        if (verifReste == false) {
          notify(2, "Le produit n’est recommandable que par multiple de carton");
          return
        }
        entities.forEach((data) => {
          // Check for idProduit being null
          if (data.idProduit === null) {
            verif = false;
            if (!ligneMsg.includes(data.index + 1)) {
              ligneMsg.push(data.index + 1); // Add index to ligneMsg
            }
          }

          // Check for invalid Quantite values
          if (
            data.Quantite == 0 ||
            data.Quantite === "" ||
            data.Quantite === null ||
            isNaN(data.Quantite)
          ) {
            verif = false;
            if (!ligneMsg.includes(data.index + 1)) {
              ligneMsg.push(data.index + 1); // Add index if not already added
            }
          }
        });

      }
      else { verif = false; }

      var verifCmdD = await dispatch(
        verifCmd({
          numero: entitiesEntete[0].Numero,
          grossiste: entitiesEntete[0].id_grossiste
        })
      );
      var testT = await verifCmdD.payload;

      //setSave(true)
      if (verif == false) {
        if (ligneMsg.length > 0) notify(2, "Vérifier les lignes : " + ligneMsg.join(" ,"));
        else notify(2, t("erreur"));
      } else if (testT === true) {
        notify(2, t("cmd_deja"));
      } else {
        if (entitiesEntete[0].id_grossiste !== null) {
          let divise = 0;
          const types = [...new Set(entities.filter(e => parseInt(e.Quantite) > 0).map(e => e.type))];
          console.log(types)
          if (types.length > 1) {
            const result = await Swal.fire({
              title: 'Division Commande',
              text: "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande ?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Oui, diviser',
              cancelButtonText: 'Non',
            });
            if (result.isConfirmed) {
              divise = 1;
            }
          }

          if (saveTableCalled.current) return;
          saveTableCalled.current = true
          setSave(true)

          dispatch(commandeAdded({ divise, type_insert: 4, Montant: total, ligneCommande: entities, enteteCmd: entitiesEntete })).then((e) => {
            if (e.payload === true) {
              notify(1, t("add_txt"));
              setTimeout(() => {
                window.location.replace(client + "/commandeList")
              }, 1000);
            } else {
              setSave(false)
              saveTableCalled.current = false
              notify(2, t("erreur"));
            }
          });
        } else {
          notify(2, t("Grossiste.obligatoire"));
        }
      }

    },
    [dispatch]
  );
  const calculateTotalSum = (entities) => {
    const sum = entities.reduce((acc, curr) => {
      return acc + parseFloat(curr.total || 0); // add total to accumulator, default to 0 if total is undefined
    }, 0); // initial accumulator value is 0

    setTotal(sum);
  };

  //get grossiste
  const getGrossiste = useCallback(async () => {
    var grossiste = await dispatch(fetchGrossisteSite({client}));
    var entities = grossiste.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id_grossiste, label: e.raison_sociale, remise_industrie3: e.grossistes?.remise_industrie3, remise_industrie2:  e.grossistes?.remise_industrie2 })
    });
    setOptionFour(arrayOption);
  }, [dispatch]);

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getNumCmd(idUser)
    getproduit(client)
   if(obj.user.id_role != 6 )getGrossiste();
  }, [numCmd]);

  return (
    <>
      <Container fluid>
        <ToastContainer />
        {alert}
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={() => {
                window.history.back();
              }}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              {t('list')}
            </Button>
          </Col>
        </Row>
        <div className="section-image">
          <Card>
            <Card.Header>
              <Card.Title as="h4">{t('new_commande')}</Card.Title>
              <hr></hr>
              <Card.Title as="h4">{t('commande')} N° {numCmd}</Card.Title>
            </Card.Header>
            <Card.Body>
              {obj.user.id_role != 6 && (

                <Select
                  className="react-select"
                  name="Grossiste"
                  placeholder="Grossiste"
                  value={fourSelected}
                  onChange={(v) => {
                    console.log("👉 Test L : nouveau grossiste sélectionné", v); // 🔥 test log

                    setFourSelected(v);
                    var prev = [...entitiesEntete];
                    prev[0].Grossiste = v.label;
                    prev[0].id_grossiste = v.value;
                    prev[0].remise_industrie3 = v.remise_industrie3;
                    prev[0].remise_industrie2 = v.remise_industrie2;

                    setRemise_industrie2(v.remise_industrie2);
                    setRemise_industrie3(v.remise_industrie3);

                    // 🔥 test recalcul remise
                    const updatedEntities = entities.map(e => {
                      let remiseDecimal = 0;
                      let remise = 0
                      remiseDecimal = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                      remise = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                      if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;


                      console.log("👉 Test L - recalcul ligne:", e.designation, "ancienne remise:", e.Remise, "nouvelle remise:", remiseDecimal);

                      return {
                        ...e,
                        Remise: remise,
                        total: e.Quantite
                          ? (e.prix * e.Quantite * (1 - remiseDecimal)).toFixed(3)
                          : 0
                      };
                    });
                    calculateTotalSum(updatedEntities)
                    setEntities(updatedEntities);
                    setEntitiesEntete(prev);
                  }}

                  options={optionFour}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                />
              )}

              <h4 className="float-left"><strong>{t('montant_total')}: {new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(total)} HT TND</strong></h4>
              <Row className="float-right" style={{ width: "50%", margin: "30px 0 15px" }}>
                <Col md="12">
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Check>
                          <Form.Check.Label>
                            <Form.Check.Input
                              type="checkbox"
                              checked={resteZero == 1 ? true : false}
                              onChange={(v) => {
                                if (v.target.checked) {
                                  setResteZero(1);
                                  getProduitReste(entities, 1)
                                }
                                else setResteZero(0)
                              }}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            <label>{t('produit_en_vrac')}</label>
                          </Form.Check.Label>
                        </Form.Check>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br clear="all"></br>
              <hr clear="all"></hr>
              <table className="table table-add table-bordered">
                <thead>
                  <tr className="table-info">
                    <th>{t('ID')}</th>
                    <th>{t('code_pct')}</th>
                    <th>{t('code_article')}</th>
                    <th>{t('designation')}</th>
                    <th>{t('remise')}</th>
                    <th>{t('prix')} (HT TND)</th>
                    <th>{t('cartonnage')}</th>
                    <th>{t('quantite_cmd')}</th>
                    <th>{t('nb_carton')}</th>
                    <th>{t('reste')}</th>
                    <th>{t('prix_total')} (HT TND)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="commande-import4">
                  {(resteZero ? entitiesReste : entities).map((row, rowIndex) => {
                    const isResteZero = resteZero === 1;

                    const handleChangeQuantite = (e) => {
                      const newValue = e.target.value.replace(/[^0-9]/g, "");

                      if (isResteZero) {
                        // Update entitiesReste
                        setEntitiesReste(prev => {
                          const newEntities = [...prev];
                          newEntities[rowIndex] = { ...newEntities[rowIndex], Quantite: newValue };
                          return newEntities;
                        });

                        // Also update entities
                        setEntities(prev => {
                          const newEntities = [...prev];
                          const idx = row.index; // map to main entities
                          newEntities[idx] = { ...newEntities[idx], Quantite: newValue };
                          return newEntities;
                        });
                      } else {
                        setEntities(prev => {
                          const newEntities = [...prev];
                          newEntities[rowIndex] = { ...newEntities[rowIndex], Quantite: newValue };
                          return newEntities;
                        });
                      }
                    };

                    const handleBlurQuantite = (e) => {
                      let rawQuantite = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;

                      const updateEntities = (prev) => {
                        const newEntities = [...prev];
                        const cart = newEntities[rowIndex].cartonnage;

                        if (cart > 0) {
                          newEntities[rowIndex].nb = Math.floor(rawQuantite / cart);
                          const mod = rawQuantite % cart;
                          newEntities[rowIndex].reste = mod > 0 ? cart - mod : 0;
                        }

                        // Cartonnage rounding (tag === 2)
                        if (
                          newEntities[rowIndex].cartonnage > 0 &&
                          rawQuantite / newEntities[rowIndex].cartonnage >= 0.6 &&
                          newEntities[rowIndex].reste > 0 &&
                          newEntities[rowIndex].tag === 2
                        ) {
                          const seuil = newEntities[rowIndex].cartonnage * 0.6;
                          rawQuantite =
                            Math.ceil(rawQuantite / newEntities[rowIndex].cartonnage) *
                            newEntities[rowIndex].cartonnage;
                          newEntities[rowIndex].style = "red"
                          notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
                        }

                        newEntities[rowIndex].Quantite = rawQuantite;

                        // Remise
                        let remiseDecimal = 0;
                        if (newEntities[rowIndex].Remise && newEntities[rowIndex].Remise !== 0) {
                          remiseDecimal =
                            typeof newEntities[rowIndex].Remise === "number"
                              ? newEntities[rowIndex].Remise
                              : parseFloat(newEntities[rowIndex].Remise);
                          if (remiseDecimal > 1) remiseDecimal /= 100;
                        }

                        // Nb & reste pour tag === 1
                        if (cart > 0) {
                          newEntities[rowIndex].nb = Math.floor(rawQuantite / cart);
                          const mod = rawQuantite % cart;
                          newEntities[rowIndex].reste = mod > 0 ? cart - mod : 0;

                          if (newEntities[rowIndex].tag === 1 && newEntities[rowIndex].reste > 0) {
                            newEntities[rowIndex].Quantite += newEntities[rowIndex].reste;
                            newEntities[rowIndex].reste = 0;
                            newEntities[rowIndex].nb += 1;
                            newEntities[rowIndex].style = "red"
                            notify(2, "Le produit n’est recommandable que par multiple de carton");
                          }
                        } else {
                          newEntities[rowIndex].nb = 0;
                          newEntities[rowIndex].reste = 0;
                        }

                        // ✅ Total calculé avec la Quantité corrigée
                        newEntities[rowIndex].total = newEntities[rowIndex].Quantite
                          ? (
                            newEntities[rowIndex].prix *
                            newEntities[rowIndex].Quantite *
                            (1 - remiseDecimal)
                          ).toFixed(3)
                          : 0;

                        return newEntities;
                      };

                      if (isResteZero) {
                        setEntitiesReste((prev) => {
                          const updated = updateEntities(prev);
                          //calculateTotalSum(updated); // ✅ recalcul après mise à jour
                          return updated;
                        });

                        setEntities((prev) => {
                          const updated = [...prev];
                          const idx = row.index;
                          updated[idx] = {
                            ...updated[idx],
                            ...updateEntities([row])[0], // garde ta logique si row est déjà mappé
                          };
                          calculateTotalSum(updated);
                          return updated;
                        });
                      } else {
                        setEntities((prev) => {
                          const updated = updateEntities(prev);
                          calculateTotalSum(updated); // ✅ recalcul après mise à jour
                          return updated;
                        });
                      }
                    };



                    return (
                      <tr key={row.id || rowIndex} className={row.reste > 0 ? "reste-warning" : null}>
                        <td>{row.index + 1}</td>
                        <td>
                          {row.tag === 1 && <i style={{ color: "#9C27B0", fontSize: "15px", marginRight: "5px" }} className="fa-solid fa-cube"></i>}
                          {row.code}
                        </td>
                        <td>{row.code_article}</td>
                        <td>
                          {row.idProduit !== null ? (
                            <Form.Group className="desinationProduit">
                              <Form.Control
                                className="green"
                                readOnly
                                value={row.designation}
                                placeholder="Designation"
                                type="text"
                              />
                            </Form.Group>
                          ) : (
                            <div className="table-bl">
                              {row.designation && (
                                <Form.Group className="desinationProduit">
                                  <Form.Control
                                    className="red"
                                    readOnly
                                    value={row.designation}
                                    placeholder="Designation"
                                    type="text"
                                  />
                                </Form.Group>
                              )}
                              <Select
                                className="react-select"
                                name="Produit"
                                placeholder="Produit"
                                value={row.idProduit ? { label: row.designation, value: row.idProduit } : null}
                                onChange={(v) => confirmMessageProduit(entities, produitSelect, rowIndex, v, obj, remise_industrie2, remise_industrie3)}
                                options={optionProduit}
                              />
                            </div>
                          )}
                        </td>
                        <td>{row.Remise}</td>
                        <td>{row.prix}</td>
                        <td>{row.cartonnage}</td>
                        <td>
                          <Form.Group>
                            <Form.Control
                              value={row.Quantite}
                              placeholder="Quantite"
                              className={row.style === "red" ? "redBorder form-control" : "defaultBorder form-control"}
                              type="number"
                              pattern="\d+"
                              onChange={handleChangeQuantite}
                              onBlur={handleBlurQuantite}
                              name={`Quantite-${rowIndex}`}
                            />
                          </Form.Group>
                        </td>
                        <td>{row.nb}</td>
                        <td>{row.reste}</td>
                        <td>{row.total ? parseFloat(row.total).toFixed(3) : "0.000"}</td>
                        <td>
                          <div className="actions-right block_action">
                            <Button
                              id={"idLigneR_" + rowIndex}
                              onClick={() => deleteLigne(rowIndex)}
                              variant="danger"
                              size="sm"
                              className="text-danger btn-link delete"
                            >
                              <i className="fa fa-trash" id={"idLigneR_" + rowIndex} />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

              </table>
              <br></br>
              <hr></hr>
              {!save && resteZero == 0 ? <Button
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                nom="redac"
                onClick={(ev) => AjoutLigne()}
              >
                {t("add_product")}
              </Button> : null}

              <br></br>
              <Col md="12">
                {!save ? <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-right"
                  type="button"
                  variant="info"
                  onClick={() =>
                    saveTable(entities, entitiesEntete, total)
                  }
                >
                  <span className="btn-label">
                    <i className="fas fa-check"></i>
                  </span>
                  {t("save_draft")}
                </Button> : ""}

              </Col>
            </Card.Body>
          </Card>


        </div >
      </Container >

    </>
  );
}

export default AddCommandeParProduit;
